"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.login = void 0;

var auth_1 = require("../shared/auth");

var config_1 = require("../shared/config");

var query_string_1 = require("query-string");

function login() {
  config_1.readConfig("/config").then(function (config) {
    var authClient = new auth_1.Auth(config.clientid, config.tenantid, config.redirectPathSignIn, config.oauthScopes);

    var _query_string_1$parse = query_string_1.parse(window.location.search.substr(1)),
        requestedUri = _query_string_1$parse.requestedUri;

    var requestedUriFlattend = Array.isArray(requestedUri) ? requestedUri[0] : requestedUri;
    authClient.loginWithRedirect(requestedUriFlattend || undefined);
  });
}

exports.login = login;
window.addEventListener("load", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
  return _regenerator.default.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          login();

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));
//# sourceMappingURL=index.js.map